// src/pages/Profile.jsx
import { useAuth } from "../context/authContext"; // fixed casing
import { doSignOut, doDeleteAccount } from "../auth";

export default function Profile() {
  const { user } = useAuth();
  const photo = user?.photoURL || "https://via.placeholder.com/96?text=User";
  const name = user?.displayName || "No name";
  const email = user?.email || "No email";

  const onDelete = async () => {
    if (window.confirm("Delete your account? This cannot be undone.")) {
      try {
        await doDeleteAccount(); // [web:32]
      } catch (e) {
        alert(e.message);
      }
    }
  };

  return (
    <div style={{ padding: 16 }}>
      <h2>Profile</h2>
      <img src={photo} alt="avatar" width={96} height={96} style={{ borderRadius: 8 }} />
      <p><b>Name:</b> {name}</p>
      <p><b>Email:</b> {email}</p>
      <button onClick={doSignOut}>Logout</button> {/* [web:23] */}
      <button onClick={onDelete} style={{ marginLeft: 8, color: "white", background: "crimson" }}>
        Delete Account
      </button>
    </div>
  );
}
